import React from 'react';
import Icon from '../common/Icons';
import AffiliationBadge from './AffiliationBadge';
import {
  formatCompanyContactLine,
  formatCompanyLocationLine
} from './companyListUtils';
import './AffiliationBadge.css';
import './CompanyListUx.css';

export default function CompanyListTable({
  companies,
  resolveForCompany,
  cities = [],
  activeActionCompanyId = null,
  onOpenActionMenu
}) {
  return (
    <div className="co-table-wrap co-list-table-wrap adm-mobile-table-wrap">
      <table className="co-table co-table--compact adm-mobile-table">
        <thead>
          <tr>
            <th>Société</th>
            <th>Référentiel</th>
            <th className="co-table__actions-col" aria-label="Actions" />
          </tr>
        </thead>
        <tbody>
          {companies.map((company) => {
            const contact = formatCompanyContactLine(company);
            const location = formatCompanyLocationLine(company, cities);
            const code = company.company_code || '—';
            const menuOpen = activeActionCompanyId === company.id;

            return (
              <tr
                key={company.id}
                className={[
                  company.is_active ? '' : 'co-row--inactive',
                  menuOpen ? 'adm-table-row--menu-open' : ''
                ]
                  .filter(Boolean)
                  .join(' ')}
              >
                <td className="co-cell-identity adm-mobile-card-head" data-label="Société">
                  <div className="co-identity">
                    <div className="co-identity__head">
                      <span className="co-company-code co-company-code--inline">{code}</span>
                      <span className="co-identity__name">{company.name}</span>
                      <span
                        className={`co-status-dot ${company.is_active ? 'is-active' : 'is-inactive'}`}
                        title={company.is_active ? 'Active' : 'Inactive'}
                        aria-label={company.is_active ? 'Active' : 'Inactive'}
                      />
                    </div>
                    {contact ? (
                      <span className="co-identity__meta">{contact}</span>
                    ) : (
                      <span className="co-identity__meta co-identity__meta--muted">
                        Aucun contact renseigné
                      </span>
                    )}
                  </div>
                </td>
                <td className="co-cell-ref" data-label="Référentiel">
                  <div className="co-ref-stack">
                    <AffiliationBadge
                      affiliation={resolveForCompany(company)}
                      variant="compact"
                    />
                    <span
                      className={`co-location-line ${
                        location.empty ? 'co-location-line--muted' : ''
                      }`}
                      title={location.title}
                    >
                      {location.text}
                    </span>
                  </div>
                </td>
                <td className="co-table__actions-col adm-mobile-card-actions" data-label="Actions">
                  <button
                    type="button"
                    className={`co-action-btn adm-action-btn adm-mobile-action-btn ${
                      menuOpen ? 'is-open' : ''
                    }`}
                    onClick={(event) => onOpenActionMenu(event, company)}
                    aria-label={`Actions pour ${company.name}`}
                    aria-expanded={menuOpen}
                    aria-haspopup="menu"
                    title="Actions"
                  >
                    <Icon name="ellipsis-vertical" size={16} />
                  </button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
